import React from "react";
import Carousel from "./Carousel";
import RoomHeader from "./placeHeader/RoomHeader";
import Footer from "./Footer";

const Home = (props) => {
  const cityId = props.match.params.homeId;

  return (
    <div>
      <Carousel />
      <RoomHeader props={cityId} />
      <Footer />
    </div>
  );
};

export default Home;
